import { get2bapProfilesModuleUrl } from '../modules/2bap/external/2bapProfiles/getUrls';
import { get, includes, find, endsWith } from 'lodash';
import { RouterParams } from '../utils/routerUtility/RouterParams';
import { get2bapLearnersModuleUrl } from '../modules/2bap/external/2bapLearners/getUrls';

export const EXTERNAL_MODULES_PATHS = [
  get2bapProfilesModuleUrl(),
  get2bapLearnersModuleUrl()
];

export const is2bapProfilesModuleUrl = (returnUrl) => endsWith(get2bapProfilesModuleUrl(), returnUrl);
export const is2bapLearnersModuleUrl = (returnUrl) => endsWith(get2bapLearnersModuleUrl(), returnUrl);

export function isExternalModuleRoute(routerState) {
  const routerParams = new RouterParams();
  if (routerParams.returnUrl) {
    return includes(EXTERNAL_MODULES_PATHS, `/${routerParams.returnUrl}`);
  }

  const path = get(routerState, 'location.pathname', '');
  return Boolean(
    find(EXTERNAL_MODULES_PATHS, externalPath => path.indexOf(externalPath) !== -1)
  );
}
